import BaseListagem from "components/BaseListagem";
import { Column } from "primereact/column";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import FeriadoService from "service/administracao/cadastro/FeriadoService";
import { converterData, converterDataDiaMes } from "utils/convert";

const feriadoService = new FeriadoService();

export default function FeriadoListagem() {

    const [queryParameters] = useSearchParams();

    useEffect(() => {
    }, []);

    return (

        <BaseListagem ordenacao="nome,ASC" service={feriadoService} urlService="/feriado" tituloPagina={'Feriados'} >
            <Column field="nome" header="Nome" />
            <Column field="data" header="Data" body={(data) => data.replicaAnualmente ? converterDataDiaMes(data.data) : converterData(data.data)} />
            <Column field="cobrareplicaAnualmentenca" header="Tipo" body={(data) => data.replicaAnualmente ? 'Todos os anos' : 'Único'} />
        </BaseListagem>
    )
}
